import __var_0__ from './factory.js';
/**

*
* Copyright (c) 2018 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

// MODULES //
var factory = __var_0__;


// MAIN //

/**
* Returns a standard normal random number.
*
* @name normal
* @type {PRNG}
* @returns {number} pseudorandom number
*
* @example
* var v = normal();
* // returns <number>
*/
var normal = factory();


// EXPORTS //
export default normal;
